import { useHistory, useLocation } from 'react-router-dom';

export default function useCustomSearchParams() {
  const history = useHistory();
  const location = useLocation();

  const getParams = (name: string, defaultValue = '') => {
    const searchParams = new URLSearchParams(location.search);

    return searchParams.get(name) || defaultValue;
  };

  const setParams = (name: string, value: string | number) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(name, String(value));
    history.push({ search: searchParams.toString() });
  };

  const setMultipleParams = (
    args: { name: string; value: string | number }[]
  ) => {
    const searchParams = new URLSearchParams(location.search);
    args.forEach((arg) => searchParams.set(arg.name, String(arg.value)));
    history.push({ search: searchParams.toString() });
  };

  // getAllParams 구현은 생략되었습니다. 필요에 따라 추가하세요.

  return {
    getParams,
    setParams,
    setMultipleParams,
  };
}

interface Params {
  [name: string]: Param
}

type Param = string | string[] | number
